import * as React from "react";
import styled from "styled-components";
import { ConferenceInterface, getConferenceStatusCN } from "@/types";
import { Button } from "antd";

const Container = styled.div`
  width: 400px;
  .atitle {
    height: 40px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    padding-top: 15px;
  }
  .item {
    display: flex;
    align-items: center;
    margin-top: 25px;
    .l {
      width: 200px;
    }
  }
`;

interface AppointPreviewProp {
  conference: ConferenceInterface;
  onClose: () => void;
  onDelete: (roomId: string, operation: string) => void;
}

const AppointPreview: React.FC<AppointPreviewProp> = ({
  conference,
  onClose,
  onDelete,
}) => {
  const okHandler = () => {
    onDelete(conference.roomId, "delete");
  };

  return !conference ? (
    <></>
  ) : (
    <div
      className="modal f jc"
      // okText="删除"
      // cancelText="返回"
      // onOk={okHandler}
      // onCancel={onClose}
      // visible={!!conference}
      // centered
      // width={450}
    >
      <Container>
        <div className="atitle mt30 jsc">会议详情</div>
        <div className="item mt25">
          <div>{conference.title}</div>
        </div>
        <div className="item">
          <span className="l">入会时间</span>
          <span>{conference.beginTime}</span>
        </div>
        <div className="item">
          <span className="l">退会时间</span>
          <span>{conference.endTime}</span>
        </div>
        <div className="item">
          <span className="l">时区</span>
          <span>中国</span>
        </div>
        <div className="item">
          <span className="l">累计参会时长</span>
          <span>{conference.duration}</span>
        </div>
        <div className="item">
          <span className="l">会议号</span>
          <span>{conference.conferenceNo}</span>
        </div>
        <div className="item">
          <span className="l">发起人</span>
          <span>{conference.ownerName}</span>
        </div>
        <div className="item">
          <span className="l">会议类型</span>
          <span>{ conference.type}</span>
        </div>
        <div className="item">
          <span className="l">会议状态</span>
          <span>{getConferenceStatusCN(conference.status)}</span>
        </div>
        <div className="mt40 jssb">
          {/* <Button className="w160" type="primary" danger onClick={okHandler}>
            删除
          </Button> */}
          <Button className="w160" onClick={onClose}>
            返回
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default AppointPreview;
